"use client"

import { Form, FormItemProps } from "antd"
import { FC } from "react"
import { Controller, ControllerProps } from "react-hook-form"
import { useTranslation } from "react-i18next"

type ControllerWarpperProps = FormItemProps & {
  render: ControllerProps['render']
  // RHF 7.55+ Control is invariant (TFieldValues vs TTransformedValues from yup).
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  control: any
}

const ControllerWarpper: FC<ControllerWarpperProps> = ({ render, control, name, help, ...props }) => {
  const { t } = useTranslation()
  return (
    <Controller
      name={name}
      control={control}
      render={(renderParams) => {
        const { error } = renderParams.fieldState
        const _error = error ? Array.isArray(error) ? error[0] : error : null
        return (
          <Form.Item
            {...props}
            {...(_error ? {
              validateStatus: 'error',
              help: (
                <>
                  <div>{t(`${_error.message}`)}</div>
                  {help ? <div style={{ marginTop: '0.4rem' }}>{help}</div> : null}
                </>
              ),
            } : help !== undefined ? { help } : {})}
          >
            {render(renderParams)}
          </Form.Item>
        )
      }}
    />
  )
}

export default ControllerWarpper
